import React from 'react';
import { CheckCircle2, Zap, Award, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Zap className="w-6 h-6 text-blue-600" />,
      title: 'Affordable Pricing',
      description: 'Quality web solutions that fit your budget without compromising on excellence.'
    },
    {
      icon: <CheckCircle2 className="w-6 h-6 text-blue-600" />,
      title: 'Clean Code',
      description: 'Well-structured, maintainable code following industry best practices.'
    },
    {
      icon: <Award className="w-6 h-6 text-blue-600" />,
      title: 'Fast Delivery',
      description: 'Efficient development process ensuring your project launches on time.'
    },
    {
      icon: <Users className="w-6 h-6 text-blue-600" />,
      title: 'Client Satisfaction',
      description: 'Dedicated support and communication throughout the development journey.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            About <span className="text-blue-600">Anita Consultancy Services</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            A modern web development agency focused on building fast, responsive websites and scalable web applications with clean UI/UX designs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 bg-slate-50 rounded-2xl hover:bg-blue-50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">{feature.title}</h3>
              <p className="text-slate-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-3xl text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-4">Our Mission</h3>
            <p className="text-lg text-blue-100">
              To empower startups, small businesses, and individuals with professional web solutions that are both affordable and high-quality. We believe every business deserves a powerful online presence without breaking the bank.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;